module.exports = __webpack_public_path__ + "static/media/Level_two.3d797537.svg";